import { baseApi, defaultQueryFreshness } from "./baseApi";

interface ApiPayload extends Record<string, unknown> {
  message?: string;
}

export const draftsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchDrafts: builder.query<unknown, void>({
      query: () => ({ url: "/drafts", method: "GET" }),
      providesTags: [{ type: "Drafts", id: "LIST" }],
      ...defaultQueryFreshness,
    }),
    saveDraft: builder.mutation<ApiPayload, ApiPayload>({
      query: (draftData) => ({ url: "/drafts", method: "POST", data: { draft: draftData } }),
      invalidatesTags: [{ type: "Drafts", id: "LIST" }],
    }),
    updateDraft: builder.mutation<ApiPayload, { id: string; draftData: ApiPayload }>({
      query: ({ id, draftData }) => ({ url: `/drafts/${id}`, method: "PATCH", data: { draft: draftData } }),
      invalidatesTags: (_res, _err, { id }) => [{ type: "Drafts", id: String(id) }, { type: "Drafts", id: "LIST" }],
    }),
    deleteDraft: builder.mutation<unknown, string>({
      query: (id) => ({ url: `/drafts/${id}`, method: "DELETE" }),
      invalidatesTags: (_res, _err, id) => [{ type: "Drafts", id: String(id) }, { type: "Drafts", id: "LIST" }],
    }),
  }),
});

export const { useFetchDraftsQuery, useSaveDraftMutation, useUpdateDraftMutation, useDeleteDraftMutation } = draftsApi;
